import type { FC } from 'react';
import { Button } from 'react-bootstrap';
import { classes, stylesheet } from 'typestyle';

export type JImageMenuProps = {
  canRemove: boolean;
  disabled: boolean;
  onReplace: () => void;
  onRemove: () => void;
  onViewFullSize: () => void;
};

const css = stylesheet({
  container: {
    $nest: {
      '.btn': {
        color: '#000',
        fontSize: 38,
      },
    },
    maxWidth: 'none',
    overflow: 'hidden',
    zIndex: 1035,
  },
  overlay: {
    alignItems: 'center',
    background: '#fff',
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    opacity: 0.5,
    position: 'absolute',
    right: 0,
    top: 0,
  },
});

export const JImageMenu: FC<JImageMenuProps> = ({ canRemove, disabled, onRemove, onReplace, onViewFullSize }) => (
  <div className={classes(css.container, 'jimg-menu')}>
    <div className={css.overlay}>
      <Button data-cy="replace-img-btn" disabled={disabled} onClick={onReplace} title="Replace the media" type="button" variant="light">
        <i className="fa fa-upload" />
      </Button>
      {canRemove && (
        <Button
          data-cy="remove-img-btn"
          disabled={disabled}
          onClick={onRemove}
          title="Remove media from campaign"
          type="button"
          variant="light"
        >
          <i className="fa fa-trash" />
        </Button>
      )}
      <Button
        data-cy="fullsize-img-btn"
        disabled={disabled}
        onClick={onViewFullSize}
        title="View the full size of the media"
        type="button"
        variant="light"
      >
        <i className="fa fa-arrows-alt" />
      </Button>
    </div>
  </div>
);
